import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-1"
}

import { IonText } from '@ionic/vue';
    

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorMessage',
  props: {
        text: {
            type: String,
        },
    },
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  return (__props.text)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonText), {
          color: "danger",
          class: "fs-14"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.text), 1)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})